import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2d70bbe2&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=2d70bbe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../igs3-fontend-prod353/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70bbe2",
  null
  
)

export default component.exports